import { useMemo } from 'react';
import { useSquad } from '../lib/squadContext.ts';
import { age, CLUB_TRAINED_REQUIRED, HOMEGROWN_REQUIRED, LIST_A_LIMIT } from '../lib/rules.ts';
import { C } from '../lib/theme.ts';

/** The UEFA List A / List B pair closing the tactics section. */
export default function UefaLists() {
  const { listRules, shortName, playerHandles } = useSquad();

  const listA = useMemo(() => {
    return {
      title:
        listRules.listA.length +
        '/' +
        listRules.listACapacity +
        ' · HG ' +
        listRules.homegrown.length +
        '/' +
        HOMEGROWN_REQUIRED +
        ' · KA ' +
        listRules.clubTrained.length +
        '/' +
        CLUB_TRAINED_REQUIRED,
      players: listRules.listA
        .slice()
        .sort((a, b) => b.rating - a.rating)
        .map((p) => ({
          id: p.id,
          name: shortName(p),
          badge: p.homegrown === 'kulup' ? ' · KA' : p.homegrown === 'ulke' ? ' · HG' : '',
          bg: p.homegrown !== 'yok' ? C.ink : C.bg,
          fg: p.homegrown !== 'yok' ? C.bg : C.ink,
        })),
      note:
        listRules.homegrownShort > 0 || listRules.clubTrainedShort > 0
          ? 'Kota eksik: liste ' +
            LIST_A_LIMIT +
            ' yerine ' +
            listRules.listACapacity +
            ' kişiyle bildirilir. Her eksik yetiştirilmiş oyuncu bir slotu yakar.'
          : 'Kota tamam. Kalan ' +
            Math.max(0, listRules.listACapacity - listRules.listA.length) +
            ' slot serbest — sezon içi transferler için saklanabilir.',
    };
  }, [listRules, shortName]);

  const listB = useMemo(() => {
    return {
      title: listRules.listB.length + ' oyuncu',
      players: listRules.listB.map((p) => ({ id: p.id, name: shortName(p), age: age(p) })),
      note: 'Liste B sınırsızdır: 2005 ve sonrası doğumlu, 15 yaşından itibaren iki yıl kesintisiz kulüpte bulunan oyuncular Liste A slotu harcamadan kadroya yazılır.',
    };
  }, [listRules, shortName]);

  return (
    <div
      style={{
        borderTop: `2px solid ${C.ink}`,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
      }}
    >
      <div style={{ borderRight: `2px solid ${C.ink}` }}>
        <div
          style={{
            padding: '10px 16px',
            background: C.surface,
            borderBottom: `1px solid ${C.line}`,
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: '0.14em',
          }}
        >
          UEFA LİSTE A — {listA.title}
        </div>
        <div style={{ padding: '12px 16px', display: 'flex', flexWrap: 'wrap', gap: 5 }}>
          {listA.players.map((o) => (
            <span
              key={o.id}
              {...playerHandles(o.id)}
              style={{
                fontSize: 10.5,
                fontWeight: 700,
                padding: '3px 7px',
                background: o.bg,
                color: o.fg,
                border: `1px solid ${C.ink}`,
                cursor: 'grab',
                whiteSpace: 'nowrap',
              }}
            >
              {o.name}
              {o.badge}
            </span>
          ))}
        </div>
        <div
          style={{
            padding: '0 16px 14px',
            fontSize: 11,
            lineHeight: 1.5,
            color: C.ink2,
            textWrap: 'pretty',
          }}
        >
          {listA.note}
        </div>
      </div>
      <div>
        <div
          style={{
            padding: '10px 16px',
            background: C.surface,
            borderBottom: `1px solid ${C.line}`,
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: '0.14em',
          }}
        >
          UEFA LİSTE B — {listB.title}
        </div>
        <div style={{ padding: '12px 16px', display: 'flex', flexWrap: 'wrap', gap: 5 }}>
          {listB.players.map((o) => (
            <span
              key={o.id}
              {...playerHandles(o.id)}
              style={{
                fontSize: 10.5,
                fontWeight: 700,
                padding: '3px 7px',
                background: C.bg,
                color: C.ink,
                border: `1px solid ${C.ink}`,
                cursor: 'grab',
                whiteSpace: 'nowrap',
              }}
            >
              {o.name} · {o.age}
            </span>
          ))}
        </div>
        <div
          style={{
            padding: '0 16px 14px',
            fontSize: 11,
            lineHeight: 1.5,
            color: C.ink2,
            textWrap: 'pretty',
          }}
        >
          {listB.note}
        </div>
      </div>
    </div>
  );
}
